<template>
    <div class="table-empty-chart">
        <loading-wave v-if="loading" />
        <a-empty v-else>
            <template #image>
                <i class="material-icons empty-icon">insert_chart</i>
            </template>
            <template #description>
                <span class="empty-text">{{ message }}</span>
            </template>
            <a-button type="primary" @click="$emit('edit')">
                {{ buttonText }}
            </a-button>
        </a-empty>
    </div>
</template>

<script>
import Vue from "vue";
import LoadingWave from "../../../../../../../components/common/LoadingWave.vue";

export default Vue.extend({
    name: "EmptyChart",
    components: {
        LoadingWave
    },
    props: {
        error: {
            type: [String, Object],
            default: null,
        },
        hasValidSettings: {
            type: Boolean,
            default: false,
        },
        loading: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        message() {
            if (!this.hasValidSettings) return "Grafik ayarları yapılmamış";
            if (!this.error) return "Veri bulunamadı";

            switch (this.error) {
                case "missing_x_axis":
                    return "X ekseni ayarları eksik";
                case "missing_y_axis":
                    return "Y ekseni hesaplama tipi eksik";
                case "invalid_x_axis_field":
                    return "X ekseni alanı bulunamadı";
                default:
                    return this.error.message || "Grafik verisi yüklenemedi";
            }
        },
        buttonText() {
            return this.hasValidSettings ? "Grafik Ayarlarını Düzenle" : "Grafik Ayarlarını Yap";
        },
    },
});
</script>

<style lang="scss">
.table-empty-chart {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 16px;

    .ant-empty-image {
        height: unset !important;
        margin-bottom: 0 !important;
    }
    .empty-icon {
        font-size: 48px;
        color: #bfbfbf;
        margin-bottom: 16px;
    }

    .empty-text {
        color: rgba(0, 0, 0, 0.45);
        font-size: 14px;
        text-align: center;
        word-break: break-word;
    }
}
</style>
